export const labelsExposicoes = {
  'inseminacao': {
    nome: 'Inseminação Artificial'
  },
  'monta-natural': {
    nome: 'Monta Natural'
  }
}